module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_hotel-744c89948220706c1d075d51f68a8273.svg";